/**
 * API origin for Axios/fetch URLs.
 * Empty string => same-origin relative `/api/...` (nginx proxy).
 * Guards against CI baking the literal strings "null" / "undefined".
 */
export function getApiBase() {
  const raw = process.env.REACT_APP_NODE_URL;
  if (raw == null) return "";
  const trimmed = String(raw).trim();
  if (!trimmed || trimmed === "null" || trimmed === "undefined") return "";
  return trimmed.replace(/\/$/, "");
}

export function apiUrl(path) {
  const base = getApiBase();
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${base}${normalized}`;
}
